import { createContext, useContext } from "react";

const SelectedCustomerAccessContext = createContext(null);

export const SelectedCustomerAccessProvider = SelectedCustomerAccessContext.Provider;

export const useSelectedCustomerAccess = () =>
  useContext(SelectedCustomerAccessContext);
